import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import {generateUrl, routes} from "helpers/routes";
import {Link} from "react-router-dom";
import {FormattedMessage, FormattedHTMLMessage} from "react-intl";
import InputFormGroup from "components/Form/InputFormGroup";
import {Button, Alert, Col} from 'reactstrap';
import Loading from "components/Loading";
import PhoneInputFormGroup from "components/Form/PhoneInputFormGroup";
import {countryCodeOptions} from "helpers/phone";

class Registration extends React.Component {
    static propTypes = {
        onFormSubmit: PropTypes.func.isRequired,
        onVatPayerChange: PropTypes.func.isRequired,
        status: PropTypes.shape({
            type: PropTypes.string.isRequired,
            message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
        }),
        loading: PropTypes.bool,
    };

    componentWillMount() {
        this.setState({
            formValid: false,
            agreementTaCChecked: false,
            agreementPDPCChecked: false,
            model: {}
        })
    }

    onFormChange(model) {
        this.setState({
            model,
        });
        this.props.onVatPayerChange(model.vatPayer);
    }

    onAgreementChangeTaC(e) {
        this.setState({
            agreementTaCChecked: e.target.checked
        });
    }

    onAgreementChangePDPC(e) {
        this.setState({
            agreementPDPCChecked: e.target.checked
        });
    }

    render() {
        const {onFormSubmit, status, loading} = this.props;
        const showButton = !status || status.type !== 'success';

        return (
            <div>
                <h1>
                    <strong>Placene</strong>volani.cz
                </h1>
                <p className="lead">
                    <FormattedMessage id="registration.motto" defaultMessage="Provide your services"/>.
                </p>

                {showButton &&
                <Formsy onValidSubmit={onFormSubmit} onValid={() => this.setState({formValid: true})}
                        onInvalid={() => this.setState({formValid: false})} onChange={::this.onFormChange}
                        className="form">
                    <div className="btn-group btn-group-register mb-4" role="group">
                        <Link to={generateUrl(routes.registration)} className="btn btn-outline-primary active">
                            <FormattedMessage id="nav.registration" defaultMessage="Register"/>
                        </Link>
                        <Link to={generateUrl(routes.login)} className="btn btn-outline-primary">
                            <FormattedMessage id="nav.login" defaultMessage="Login"/>
                        </Link>
                    </div>

                    <InputFormGroup type="email" name="email" id="email" validations="isEmail" required
                                    validationErrors={{
                                        isEmail: (<FormattedMessage id="form.error.is_email"
                                                                    defaultMessage="Email is not valid"/>)
                                    }}
                                    label={(<FormattedMessage id="registration.email_label" defaultMessage="E-mail"/>)}
                    />
                    <InputFormGroup type="password" name="password" id="password" validations="minLength:8" required
                                    validationErrors={{
                                        minLength: (<FormattedMessage id="form.error.password_min_length"
                                                                      defaultMessage="Your password must have at least {limit, plural, one {# character} other {# characters}}"
                                                                      values={{limit: 8}}/>)
                                    }}
                                    label={(
                                        <FormattedMessage id="registration.password_label" defaultMessage="Password"/>)}
                    />
                    <InputFormGroup type="password" name="passwordConfirm" id="passwordConfirm" required
                                    validations="equalsField:password"
                                    validationErrors={{
                                        equalsField: (<FormattedMessage id="form.error.password_match"
                                                                        defaultMessage="Passwords does not match"/>)
                                    }}
                                    label={(<FormattedMessage id="registration.password_confirmation_label"
                                                              defaultMessage="Repeat password"/>)}
                    />
                    <PhoneInputFormGroup name="phone" id="phone" required
                                         value="+420"
                                         countryOptions={countryCodeOptions}
                                         validations={{
                                             matchRegexp: /^(00|\+)420\d{9}$/,
                                         }}
                                         validationErrors={{
                                             matchRegexp: (<FormattedMessage id="form.error.is_phone_number"
                                                                             defaultMessage="This is not valid phone number"/>)
                                         }}
                                         label={(<FormattedMessage id="registration.phone_label"
                                                                   defaultMessage="Phone number"/>)}
                    />
                    <PhoneInputFormGroup name="contactPhone" id="contactPhone"
                                         countryOptions={countryCodeOptions}
                                         validations={{
                                             matchRegexp: /^(00|\+)420\d{9}$/,
                                         }}
                                         validationErrors={{
                                             matchRegexp: (<FormattedMessage id="form.error.is_phone_number"
                                                                             defaultMessage="This is not valid phone number"/>)
                                         }}
                                         label={(<FormattedMessage id="registration.phone_contact_label"
                                                                   defaultMessage="Contact phone number"/>)}
                    />
                    <InputFormGroup type="text" name="name" id="name" required
                                    label={(
                                        <FormattedMessage id="registration.name_label" defaultMessage="Given name"/>)}
                    />
                    <InputFormGroup type="text" name="surname" id="surname" required
                                    label={(
                                        <FormattedMessage id="registration.surname_label" defaultMessage="Surname"/>)}
                    />
                    <InputFormGroup type="text" name="identNum" id="identNum" required
                                    validations={{
                                        matchRegexp: /^\d{8}$/,
                                    }}
                                    validationErrors={{
                                        matchRegexp: (<FormattedMessage id="form.error.is_identification_number"
                                                                        defaultMessage="This is not valid identification number"/>)
                                    }}
                                    label={(
                                        <FormattedMessage id="registration.ident_num_label"
                                                          defaultMessage="Identification number"/>)}
                    />
                    <InputFormGroup type="text" name="businessName" id="businessName" required
                                    label={(
                                        <FormattedMessage id="registration.business_name_label"
                                                          defaultMessage="Business name"/>)}
                    />
                    <InputFormGroup type="textarea" name="businessAddress" id="businessAddress" required
                                    label={(
                                        <FormattedMessage id="registration.business_address_label"
                                                          defaultMessage="Business address"/>)}
                    />
                    <InputFormGroup type="textarea" name="correspondenceAddress" id="correspondenceAddress"
                                    label={(
                                        <FormattedMessage id="registration.correspondence_address_label"
                                                          defaultMessage="Correspondence address"/>)}
                    />
                    <InputFormGroup type="checkbox" name="vatPayer" id="vatPayer"
                                    label={(
                                        <FormattedMessage id="registration.vat_payer_label"
                                                          defaultMessage="VAT payer?"/>)}
                    />
                    {this.state.model.vatPayer &&
                    <InputFormGroup type="text" name="tin" id="tin" required={this.state.model.vatPayer}
                                    validations={{
                                        matchRegexp: /^[A-Za-z]{2}\d{8,10}$/,
                                    }}
                                    validationErrors={{
                                        matchRegexp: (<FormattedMessage id="form.error.is_vat_number"
                                                                        defaultMessage="This is not valid VAT number"/>)
                                    }}
                                    label={(
                                        <FormattedMessage id="registration.tin_label"
                                                          defaultMessage="Tax Identification Number"/>)}
                    />
                    }
                    <InputFormGroup type="text" name="ban" id="ban"
                                    validations={{
                                        matchRegexp: /^((\d{1,6}-\d{10})|(\d{0,10}))\/\d{4}$/,
                                    }}
                                    validationErrors={{
                                        matchRegexp: (<FormattedMessage id="form.error.is_bank_account_number"
                                                                        defaultMessage="This is not valid bank account number"/>)
                                    }}
                                    label={(
                                        <FormattedMessage id="registration.ban_label"
                                                          defaultMessage="Bank account number"/>)}
                    />
                    <InputFormGroup type="text" name="www" id="www"
                                    validations={{
                                        matchRegexp: /^(https?:\/\/)?(\w+\.)+[a-z]{2,8}$/,
                                    }}
                                    validationErrors={{
                                        matchRegexp: (<FormattedMessage id="form.error.is_www_page"
                                                                        defaultMessage="This is not valid domain address"/>)
                                    }}
                                    label={(
                                        <FormattedMessage id="registration.www_label"
                                                          defaultMessage="Website address"/>)}
                    />
                    <InputFormGroup type="checkbox" name="pdpc" id="pdpc" validations="isTrue" required
                                    onChange={::this.onAgreementChangePDPC}
                                    validationErrors={{
                                        isTrue: (<FormattedMessage id="form.error.agreement.pdpc"
                                                                   defaultMessage="You have to agree to the personal data processing policy"/>)
                                    }}
                                    label={(
                                        <FormattedHTMLMessage id="registration.agreement.pdpc"
                                                              defaultMessage="I agree to the <a href={url} target={target}>personal data processing policy</a>"
                                                              values={{
                                                                  url: 'https://api.placenevolani.cz/assets/pdf/ochrana_osobnich_udaju_placenevolani.pdf',
                                                                  target: '_blank'
                                                              }}/>)}
                    />
                    {status && status.type === 'danger' &&
                    <Alert color={status.type}>
                        {status.message}
                    </Alert>
                    }

                    {!this.state.formValid &&
                    <Alert color="danger">
                        <FormattedMessage id="registration.form.fill_all_fields"
                                          defaultMessage="Please fill in all required fields"/>
                        <br/>
                        {!(this.state.agreementTaCChecked && this.state.agreementPDPCChecked) &&
                        <FormattedMessage id="registration.form.agreement_needed"
                                          defaultMessage="You have to agree to the terms and conditions"/>
                        }
                    </Alert>
                    }

                    <Button disabled={!this.state.formValid || loading} type="submit" block className="btn-clickable">
                        {loading &&
                        <span className="pr-3">
                            <Loading inline small/>
                        </span>
                        }
                        <FormattedMessage id="registration.form.submit" defaultMessage="Create account"/>
                    </Button>
                </Formsy>
                }

                {status && status.type === 'success' &&
                <Col md={{size: 6, offset: 3}} style={{whiteSpace: 'pre-wrap', textAlign: 'center'}}>
                    <Alert color={status.type}>
                        {status.message}
                    </Alert>
                </Col>
                }
            </div>
        )
    }
}

export default Registration;


// WEBPACK FOOTER //
// ./src/containers/Registration/Registration.jsx